import { render, staticRenderFns } from "./ScreeningHistory.vue?vue&type=template&id=6fbe3cc2&scoped=true&"
import script from "./ScreeningHistory.vue?vue&type=script&lang=js&"
export * from "./ScreeningHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbe3cc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
